import type { MenuItemTagV2 } from "@/models/menu-item-v2";

export type TagGroups = Record<string, MenuItemTagV2[]>;

export function mapTags(tags: MenuItemTagV2[] | undefined): TagGroups {
  const grouped: TagGroups = {};
  for (const tag of tags ?? []) {
    const key = String(tag?.tag_type ?? "").trim().toUpperCase();
    if (!key) continue;
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(tag);
  }
  for (const key of Object.keys(grouped)) {
    grouped[key] = [...grouped[key]].sort(
      (a, b) => Number(a?.display_order ?? 0) - Number(b?.display_order ?? 0)
    );
  }
  return grouped;
}

export function hasTagCode(tags: MenuItemTagV2[] | undefined, code: string): boolean {
  const want = String(code).trim().toUpperCase();
  if (!want) return false;
  return (tags ?? []).some((t) => String(t?.tag_code ?? "").trim().toUpperCase() === want);
}

